import 'bootstrap/dist/css/bootstrap.min.css';
import './Action.css'
import {Modal, ModalBody, ModalFooter, ModalHeader} from "react-bootstrap"
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import doRequest from "../requests/requests";
import {useState} from 'react';
import Spinner from 'react-bootstrap/Spinner';
import ProgressBar from "../ProgressBar/ProgressBar";

function Action({action, closeAction, onSuccess, onError}) {
    const [loading, setLoading] = useState(false);

    const [progress, setProgress] = useState(0);

    const [processing, setProcessing] = useState(false);
    const [processingText, setProcessingText] = useState("Processing mesh..");
    const [processingDots, setProcessingDots] = useState(1);

    const onSubmit = (event) => {
        event.preventDefault()
        setLoading(true);
        setProgress(0);
        setProcessing(false)
        setProcessingDots(0)

        const body = createBodyFromFields(action.fields, event);
        console.debug("BODY " + body)
        doRequest({
            onProgress: setProgress,
            onProcessing: [setProcessingDots, setProcessing],
            uri: action.href,
            method: action.method,
            body: body,
            contentType: action.type
        })
            .then((acc) => {
                console.log("THE RESP IS " + acc)
                if (acc.ok) {
                    onSuccess?.(acc)
                } else onError?.(acc) ?? alert('Error else Action JSX 20')
            })
            .catch(error => onError?.(error) ?? alert('Error then Action JSX 22'))
            .then(_ => {
                setLoading(false)
                setProgress(0)
                setProcessing(false)
                closeAction?.()
            })
    }
    return (
        <>
            <Modal show={action !== undefined}
                   onHide={() => {
                       closeAction()
                   }}
                   data-backdrop="false"
                   className="modal hide fade in">
                {progress > 0 && !processing && <ProgressBar progress={progress}/>}
                {processing && <ProgressBar processing={processing} processingText={processingText}
                                            processingDots={processingDots}/>}
                <ModalHeader closeButton>
                    {action?.title}
                </ModalHeader>
                <ModalBody>
                    <Form onSubmit={onSubmit}>
                        <ActionBody fields={action.fields}
                                    title={action.title}
                                    onSubmit={onSubmit}
                                    closeAction={closeAction}
                                    loading={loading}/>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    {
                        action.fields !== undefined &&
                        <Button variant="outline-primary"
                                onClick={() => {
                                    closeAction()
                                }}>
                            Close
                        </Button>
                    }
                </ModalFooter>
            </Modal>
        </>
    )
}

export default Action

function ActionBody({fields, title, onSubmit, closeAction, loading}) {
    if (fields) {
        return (<>
            {
                fields.map((field) => field &&
                    <Form.Group className="mb-3" controlId={field.name} key={field.name}>
                        <Form.Label>{field.title}</Form.Label>
                        <Form.Control type={field.type}
                                      defaultValue={field.value ?? (field.type === 'number' ? 0 : '')}
                                      step={'any'}/>
                    </Form.Group>
                )
            }
            <Button variant="primary" type="submit" disabled={loading}>
                {loading ?
                    <Button variant="primary" disabled>
                        <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                        />
                        &nbsp; Loading...
                    </Button>
                    : 'Submit'}
            </Button>
        </>)
    } else {
        return (
            <div>
                <span>{title}?</span>
                <Button onClick={onSubmit}>
                    {loading ?
                        <Button variant="primary" disabled>
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                            &nbsp; Loading...
                        </Button>
                        : 'Yes'}
                </Button>
                <Button onClick={() => closeAction()} disabled={loading}>
                    {'No'}
                </Button>
            </div>)
    }
}

function createBodyFromFields(fields, event) {
    return fields?.reduce((body, field) => {
        if (field.type === 'file') {
            body.body = event.target[field.name].files[0];
            body.field = field.name;
        } else {
            const targetValue = event.currentTarget[field.name];
            if (targetValue !== undefined && targetValue !== "") {
                body[field.name] = targetValue?.value ?? targetValue;
            }
        }
        return body
    }, {});
}
